import {useDispatch, useSelector} from "react-redux"
import {selectWorkspace} from "../../../reducers/workspaceSlice"
import {
	clearTargetUser,
	MANAGE_WORKSPACE_VIEW,
	removeUserFromWorkspace, revokeAuthorInvite, setIsModifyingAuthor,
	setManageWorkspaceView, setTargetUser
} from "../../../reducers/manageWorkspaceSlice"
import {ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material"
import {ContactMail, DeleteOutline, ManageAccounts, PlaylistAddCheck, TransferWithinAStation} from "@mui/icons-material"

export function UserManagementMenu({isOpen, setIsOpen, anchorEl, member, currentUser}) {
	const dispatch = useDispatch()
	const workspace = useSelector(selectWorkspace)
	const currentUserIsWorkspaceOwner = workspace?.ownerUserId === currentUser?.id
	const targetMemberIsWorkspaceAdmin = member && member.workspacePermissions.admin
	const targetMemberIsCurrentUser = member && member.user.id === currentUser?.id


	const close = () => {
		// although the menu disappears when a menu item is selected, close is only called when a menu item is NOT selected. So we clear the target user to avoid a possible error caused by a stale manageWorkspaceSlice.targetUser
		dispatch(clearTargetUser())
		setIsOpen(false)
	}

	const handleRemoveMember = () => {
		dispatch(removeUserFromWorkspace())
		close()
	}

	if(targetMemberIsCurrentUser) {
		return null
	}

	return(
		<Menu
			open={isOpen}
			onClose={close}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: "top",
				horizontal: "right",
			}}
			transformOrigin={{
				vertical: "center",
				horizontal: "left",
			}}
		>
			{ !targetMemberIsWorkspaceAdmin && (
				<>
					<MenuItem
						onClick={() => dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.MANAGE_MEMBER))}
						dense
						divider
					>
						<ListItemIcon>
							<ManageAccounts />
						</ListItemIcon>
						<ListItemText>
							Modify permissions for this Workspace
						</ListItemText>
					</MenuItem>
					<MenuItem
						onClick={handleRemoveMember}
						disabled={member?.admin}
						dense
					>
						<ListItemIcon>
							<DeleteOutline />
						</ListItemIcon>
						<ListItemText>
							Remove user from this workspace
						</ListItemText>
					</MenuItem>
				</>
			)}
			{
				currentUserIsWorkspaceOwner &&
				!targetMemberIsCurrentUser && (
					<MenuItem
						onClick={() =>{
							dispatch(setTargetUser(member))
							dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.TRANSFER_OWNERSHIP))
						}}
						dense
					>
						<ListItemIcon>
							<TransferWithinAStation />
						</ListItemIcon>
						<ListItemText>
							Transfer Ownership
						</ListItemText>
					</MenuItem>
				)
			}
		</Menu>
	)
}

export function InviteManagementMenu({isOpen, setIsOpen, anchorEl}) {
	const dispatch = useDispatch()

	const close = () => {
		// although the menu disappears when a menu item is selected, close is only called when a menu item is NOT selected. So we clear the target user to avoid a possible error caused by a stale manageWorkspaceSlice.targetUser
		dispatch(clearTargetUser())
		setIsOpen(false)
	}

	const handleNotePermissionsClick = () => {
		dispatch(setIsModifyingAuthor(true))
		dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.NOTE_PERMISSIONS))
	}

	const handleEmailChangeClick = () => {
		dispatch(setIsModifyingAuthor(true))
		dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.INVITE_AUTHOR))
	}

	const handleRevokeInviteClick = async () => {
		dispatch(revokeAuthorInvite())
		close()
	}

	return(
		<Menu
			open={isOpen}
			onClose={close}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: "top",
				horizontal: "right",
			}}
			transformOrigin={{
				vertical: "center",
				horizontal: "left",
			}}
		>
			<MenuItem
				onClick={handleNotePermissionsClick}
				dense
			>
				<ListItemIcon>
					<PlaylistAddCheck/>
				</ListItemIcon>
				<ListItemText>
					Change note permissions for this invite
				</ListItemText>
			</MenuItem>
			<MenuItem
				onClick={handleEmailChangeClick}
				dense
				divider
			>
				<ListItemIcon>
					<ContactMail />
				</ListItemIcon>
				<ListItemText>
					Change the e-mail associated with this invite
				</ListItemText>
			</MenuItem>
			<MenuItem
				onClick={handleRevokeInviteClick}
				dense
			>
				<ListItemIcon>
					<DeleteOutline />
				</ListItemIcon>
				<ListItemText>
					Revoke author invite to this workspace
				</ListItemText>
			</MenuItem>
		</Menu>
	)
}